var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (null !== _vm.globalError)?_c('div',{staticClass:"global-error",class:[_vm.globalError ? 'show-global-error' : '']},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.globalError)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }